export const businessTypeOptions = [
  { value: 'manufacturing', label: 'Manufacturing / Production' },
  { value: 'retail', label: 'Retail / Physical Stores' },
  { value: 'services', label: 'Service Business (Salons, Clinics, etc.)' },
  { value: 'distribution', label: 'Distribution / Wholesale' },
  { value: 'food-beverage', label: 'Food & Beverage' },
  { value: 'fashion', label: 'Fashion / Apparel' },
  { value: 'professional-services', label: 'Professional Services (Consulting, Agency)' },
  { value: 'other-physical', label: 'Other Physical Goods/Services' },
];

export const yearsInOperationOptions = [
  { value: 'under-1', label: 'Less than 1 year' },
  { value: '1-3', label: '1-3 years' },
  { value: '3-5', label: '3-5 years' },
  { value: '5-10', label: '5-10 years' },
  { value: '10-plus', label: '10+ years' },
];

export const monthlyRevenueOptions = [
  { value: 'under-50k', label: 'Under $50K' },
  { value: '50k-100k', label: '$50K – $100K' },
  { value: '100k-250k', label: '$100K – $250K' },
  { value: '250k-500k', label: '$250K – $500K' },
  { value: '500k-1m', label: '$500K – $1M' },
  { value: '1m-plus', label: '$1M+' },
];

export const staffCountOptions = [
  { value: '1-5', label: '1-5 employees' },
  { value: '6-15', label: '6-15 employees' },
  { value: '16-30', label: '16-30 employees' },
  { value: '31-50', label: '31-50 employees' },
  { value: '50-plus', label: '50+ employees' },
];

export const locationOptions = [
  { value: '1', label: '1 location' },
  { value: '2-3', label: '2-3 locations' },
  { value: '4-10', label: '4-10 locations' },
  { value: '10-plus', label: '10+ locations' },
  { value: 'production-only', label: 'Production/warehouse only (no retail)' },
  { value: 'no-physical', label: 'No physical locations' },
];

export const geographyOptions = [
  { value: 'africa', label: 'Africa' },
  { value: 'uk', label: 'United Kingdom' },
  { value: 'eu', label: 'European Union' },
  { value: 'us', label: 'United States' },
  { value: 'other', label: 'Other' },
];

export const roleOptions = [
  { value: 'owner', label: 'Owner / Sole Proprietor' },
  { value: 'co-owner', label: 'Co-owner with operational authority' },
  { value: 'managing-director', label: 'Managing Director / CEO' },
  { value: 'other', label: 'Other' },
];

export const painPointOptions = [
  { value: 'financial-structure', label: 'No financial structure or visibility' },
  { value: 'supplier-coordination', label: 'Supplier and vendor coordination chaos' },
  { value: 'fulfillment-logistics', label: 'Fulfillment, logistics, or distribution issues' },
  { value: 'staff-operations', label: 'Staff scheduling and operations management' },
  { value: 'export-expansion', label: 'Export readiness or cross-border expansion' },
  { value: 'compliance-audit', label: 'Compliance, audit, or institutional readiness' },
  { value: 'process-standardization', label: 'Lack of standardized processes' },
  { value: 'owner-overload', label: 'Owner doing too much day-to-day work' },
];

export const hoursOptions = [
  { value: 'under-10', label: 'Under 10 hours' },
  { value: '10-20', label: '10-20 hours' },
  { value: '20-40', label: '20-40 hours' },
  { value: '40-plus', label: '40+ hours (full-time in operations)' },
];

export const supplierOptions = [
  { value: 'none', label: 'No external suppliers' },
  { value: '1-5', label: '1-5 suppliers' },
  { value: '6-15', label: '6-15 suppliers' },
  { value: '15-plus', label: '15+ suppliers' },
];

export const distributionOptions = [
  { value: 'local-only', label: 'Local/city only' },
  { value: 'regional', label: 'Regional (multiple cities)' },
  { value: 'national', label: 'National' },
  { value: 'international', label: 'Already exporting internationally' },
  { value: 'want-international', label: 'Seeking international expansion' },
];

export const controlAreaOptions = [
  { value: 'financial-ops', label: 'Financial operations (payables, receivables, treasury)' },
  { value: 'vendor-supplier', label: 'Vendor and supplier management' },
  { value: 'fulfillment-logistics', label: 'Fulfillment and logistics operations' },
  { value: 'process-design', label: 'Process design and standardization' },
  { value: 'staff-operations', label: 'Staff scheduling and operations' },
  { value: 'compliance-reporting', label: 'Compliance and reporting' },
];

export const commitmentOptions = [
  { value: 'exit-all', label: 'Exit all day-to-day operations (focus on vision and business development)' },
  { value: 'reduce-significant', label: 'Significantly reduce operational involvement' },
  { value: 'maintain-some', label: 'Maintain some operational involvement' },
  { value: 'unsure', label: 'I am unsure' },
];

export const goalOptions = [
  { value: 'scale-locations', label: 'Expand to more locations or territories' },
  { value: 'export', label: 'Enter export/international markets' },
  { value: 'franchise', label: 'Prepare for franchising' },
  { value: 'investment', label: 'Prepare for external investment or PE' },
  { value: 'operational-clarity', label: 'Achieve operational clarity and efficiency' },
  { value: 'owner-exit', label: 'Remove myself from day-to-day operations' },
];

export const acknowledgements = [
  'I understand that Bliu Interactive works with existing, revenue-generating businesses only.',
  'I understand that most briefs are declined and submission does not guarantee engagement.',
  'I understand that if terms are issued, they are non-negotiable.',
  'I understand that Bliu Interactive requires operational control, not advisory access.',
  'I confirm that I have the authority to make binding commitments on behalf of my business.',
  'I acknowledge that Bliu Interactive does not build apps, software products, or provide marketing services.',
];
